import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home/Home";
import Header from "./pages/Shared/Header/Header";
import Products from "./pages/Home/Products/Products";
import Footer from "./pages/Shared/Footer/Footer";
import ManageProduct from "./pages/ManageProduct/ManageProduct";
import ManageInventory from "./pages/ManageInventory/ManageInventory";
import AddNewProduct from "./pages/AddNewProduct/AddNewProduct";
import Login from "./pages/Login/Login/Login";
import Register from "./pages/Login/Register/Register";
import RequireAuth from "./pages/Login/Login/RequireAuth/RequireAuth";
import MyItem from "./pages/MyItem/MyItem";
import Blogs from "./pages/Blogs/Blogs";
import NotFound from "./pages/Shared/NotFound/NotFound";

function App() {
  return (
    <div>
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/products" element={<Products />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route
          path="/manageProduct/:productId"
          element={
            <RequireAuth>
              <ManageProduct />
            </RequireAuth>
          }
        />
        <Route
          path="/manageInventory"
          element={
            <RequireAuth>
              <ManageInventory />
            </RequireAuth>
          }
        />
        <Route
          path="/addNewProduct"
          element={
            <RequireAuth>
              <AddNewProduct />
            </RequireAuth>
          }
        />
        <Route
          path="/myItem"
          element={
            <RequireAuth>
              <MyItem />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
